export const CHAT_TOKEN_EXPIRATION_THRESHOLD = 5;
export const CHAT_BUBBLE_ID = 'chat-app-open-bubble-button';
